module.exports = __webpack_public_path__ + "img/gb-eng.5e81b715.svg";